export const USER_LOGGED = 'user.LOGGED';
export const USER_REMEMBER = 'user.REMEMBER';


// WEBPACK FOOTER //
// ./src/store/login/actionTypes.js